import { render, staticRenderFns } from "./EditorPhotofixrOrdersDetails.vue?vue&type=template&id=4f9e98c2&"
import script from "./EditorPhotofixrOrdersDetails.vue?vue&type=script&lang=js&"
export * from "./EditorPhotofixrOrdersDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports